import { IGame } from 'src/app/models/game';

export const fingerguns: IGame = {
    embedId: 1311490,
    name: 'Fingerguns',
    url: 'fingerguns'
};
